import { useState } from 'react';
import { DetailsPanel, EditIcon, FormatInformation, IconButton } from '@weareopenr/component-library';
import { IVenue } from 'src/types/venue.types';
import VenueContactModal from '../VenueContactModal/VenueContactModal';

const VenueContacts = ({ venue }: { venue: IVenue }) => {
  const [isContactsModalOpen, setIsContactsModalOpen] = useState<boolean>(false);

  const handleContactsModalToggle = (): void => setIsContactsModalOpen((prev: boolean) => !prev);
  const address = venue.addresses && venue.addresses.length > 0 ? venue.addresses[0] : null;
  return (
    <>
      <VenueContactModal
        closeModal={handleContactsModalToggle}
        open={isContactsModalOpen}
        venue={venue}
        addressId={venue.addresses?.[0]?.addressId}
      />
      <DetailsPanel
        title="Contacts"
        action={
          <IconButton
            buttonStyle="ghost"
            onClick={handleContactsModalToggle}
            icon={EditIcon}
            aria-label="Edit contacts"
          />
        }
      >
        <FormatInformation heading="Address">{address?.address || 'No Address'}</FormatInformation>
        <FormatInformation heading="Email">{address?.email || 'No Email'}</FormatInformation>
        <FormatInformation heading="Phone">{address?.phoneNumber || 'No Phone'}</FormatInformation>
      </DetailsPanel>
    </>
  );
};

export default VenueContacts;
